<template>
    <div>
        <h1>Aldehyde</h1>
        <p>
            Aldehyde sind organische Stoffe, die bei der Oxidation von
            <router-link to="alkohole">Alkoholen</router-link> (Primärer
            Alkohol) entstehen. Wichtig ist dabei, dass die C=O-Verbindung
            endständig ist. Sie bestehen aus einer üblichen
            Kohlenwasserstoffkette und einem C-Atom mit einer Einfachbindung zu
            einem H, und einer Doppelbindung zu einem O-Atom. Die
            C=O-Doppelbindung ist sehr polar, Wasserstoffbrücken bilden sich
            aber erst bei der Lösung in Wasser (da sonst kein
            sauerstoffgebundenes H-Atom vorhanden ist). Aldehyde werden
            industriell bei der Lebensmittelkonservierung und der Herstellung
            von Kunst-, Farbstoffen und Lösungsmitteln verwendet. Aldehyde
            sprechen auf die Fehling-Probe (Nachweisreaktion für Aldehyde und
            reduzierten Zucker) positiv an.
        </p>
        <img
            src="@/assets/img/stoffe/aldehyde/allgemeine-struktur.png"
            alt="Allgemeine Struktur der Aldehyde"
            title="Allgemeine Struktur der Aldehyde"
            width="128px"
            height="auto"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Homologe Reihe"></chapter-heading>
        <div class="row">
            <table class="column left">
                <tr>
                    <th>1.</th>
                    <td>H-CHO</td>
                    <td>Methanal</td>
                </tr>
                <tr>
                    <th>2.</th>
                    <td>CH<sub>3</sub>-CHO</td>
                    <td>Ethanal</td>
                </tr>
                <tr>
                    <th>3.</th>
                    <td>C<sub>2</sub>H<sub>5</sub>-CHO</td>
                    <td>Propanal</td>
                </tr>
                <tr>
                    <th>4.</th>
                    <td>C<sub>3</sub>H<sub>7</sub>-CHO</td>
                    <td>Butanal</td>
                </tr>
                <tr>
                    <td>...</td>
                </tr>
            </table>

            <table class="column left">
                <tr>
                    <th>Allgemein:</th>
                    <td>C<sub>n</sub>H<sub>2n+1</sub>-CHO</td>
                    <td><em>Alkan</em>-al</td>
                </tr>
            </table>
        </div>
        <hr class="chapter-split" />
        <chapter-heading title="Reaktionen"></chapter-heading>
        <ul>
            <li>
                Oxidation eines primären
                <router-link to="alkohole">Alkohols</router-link> => Aldehyde
            </li>
            <li>
                Oxidation eines Aldehyds =>
                <router-link to="carbon">Carbonsäure</router-link>
            </li>
        </ul>
        <hr class="chapter-split" />
        <chapter-heading
            title="Beispiel einer Strukturformel"
        ></chapter-heading>
        <img
            src="@/assets/img/stoffe/aldehyde/pentanal.png"
            alt="Beispielhafte Strukturformel: Pentanal"
            title="Beispielhafte Strukturformel: Pentanal"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Zusammenfassung"></chapter-heading>
        <table>
            <tr>
                <th>Beschreibung</th>
                <td>
                    <ul>
                        <li>
                            bestehen aus, C-Atomen, H-Atomen und einer
                            <router-link to="/gruppen/carbonyl"
                                >Carbonylgruppe</router-link
                            >
                        </li>
                        <li>
                            besitzen nur Einfachbindungen und eine
                            C=O-Doppelbindung
                        </li>
                        <li>
                            entstehen aus der Oxidation primärer
                            <router-link to="alkohole">Alkohole</router-link>
                        </li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Allgemeine Summenformel</th>
                <td>C<sub>n</sub>H<sub>2n+1</sub>CHO</td>
            </tr>
            <tr>
                <th>Allgemeine Benennung</th>
                <td><em>Alkan</em>al</td>
            </tr>
            <tr>
                <th>Eigenschaften</th>
                <td>
                    <ul>
                        <li>Dipol-Dipol-Kräfte</li>
                        <li>Wasserstoffbrücken nur in Lösung</li>
                        <li>
                            gut Wasserlöslich (nimmt mit zunehmender C-Kette ab)
                        </li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Bindungen</th>
                <td>Kohlenwasserstoffkette + endständige H-C=O</td>
            </tr>
        </table>
    </div>
</template>
<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
